/* eslint-disable react/jsx-props-no-spreading */

import classnames from 'classnames'
import React, { InputHTMLAttributes, RefObject } from 'react'

import ErrorMessage from '../ErrorMessage'
import styles from './Input.module.scss'

interface InputProps extends InputHTMLAttributes<HTMLInputElement> {
  label?: string
  requiredMessage?: string | undefined
  privateData?: boolean
  inputRef?: RefObject<HTMLInputElement>
  rounded?: boolean
  Button?: React.ReactNode
}

const Input = ({
  name = '',
  value,
  label = '',
  required = true,
  requiredMessage,
  privateData,
  inputRef,
  rounded = false,
  Button = null,
  ...rest
}: InputProps) => {
  const isPrivate = privateData && { 'data-private': 'lipsum' }

  return (
    <div
      className={classnames(styles['express-pay-input-container'], {
        [styles.filled]: value,
        [styles.error]: requiredMessage,
        [styles.rounded]: rounded,
        [styles.required]: required,
      })}
    >
      {!!label && <label htmlFor={name}>{label}</label>}
      <input id={name} name={name} value={value} ref={inputRef} {...isPrivate} {...rest} />
      {Button && <div className={styles['button-container']}>{Button}</div>}
      <ErrorMessage message={requiredMessage} />
    </div>
  )
}

export default Input
